import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Select } from '@yapay/design-system'

const formatSplit = value =>
  parseFloat(value).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })

const hasInterest = (a, b) => (a < b ? 'com juros' : 'sem juros')

const SplitSelect = ({
  availableMethods,
  totalPrice,
  paymentMethod,
  value,
  onChange,
  disabled,
  id = 'payment-option',
  required = true,
  className,
  style,
}) => {
  const splitOptions = useMemo(() => {
    if (!availableMethods || !paymentMethod) return null

    const splitByFlag = availableMethods.find(
      ({ name }) => name === paymentMethod,
    )

    if (!splitByFlag) return null

    return splitByFlag.split.map(
      ({ split, value_split, value_transaction }) => {
        const total_item = parseFloat(value_transaction, 10)
        const tax = hasInterest(totalPrice, total_item)
        return {
          value: split,
          label: `${split}x de ${formatSplit(value_split)} (${formatSplit(
            value_transaction,
          )} ${tax})`,
        }
      },
    )
  }, [availableMethods, paymentMethod, totalPrice])

  if (!splitOptions || splitOptions.length === 0) {
    return null
  }

  const hasOnlyOneSplitOption = splitOptions.length === 1
  const isDisabled = disabled || hasOnlyOneSplitOption
  const selectValue = hasOnlyOneSplitOption ? '1' : value

  return (
    <Select
      label="Escolha o parcelamento"
      id={id}
      value={selectValue}
      disabled={isDisabled}
      onChange={onChange}
      required={required}
      className={className}
      style={style}
    >
      <option />
      {splitOptions.map(option => (
        <option value={option.value} key={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  )
}

SplitSelect.propTypes = {
  availableMethods: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      split: PropTypes.arrayOf(
        PropTypes.shape({
          split: PropTypes.number.isRequired,
          value_split: PropTypes.string.isRequired,
          value_transaction: PropTypes.string.isRequired,
        }),
      ).isRequired,
    }),
  ),
  totalPrice: PropTypes.number.isRequired,
  paymentMethod: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
}

export default SplitSelect
